import Swiper, { Autoplay, Pagination } from 'swiper';

class MainNewSlider {

	constructor() {
		new Swiper('.main-news--slider', {
			modules: [Autoplay, Pagination],
			loop: false,
			grabCursor: true,
			slidesPerView: 'auto',
			spaceBetween: 10,
			breakpoints: {
				576: {
					spaceBetween: 95
				}
			},
			autoplay: {
				delay: 7000,
				disableOnInteraction: false
			},
			pagination: {
				el: document.querySelector<HTMLElement>(
					".main-news--slider .swiper-pagination"
				),
				clickable: true,
				bulletActiveClass: "_active",
				renderBullet: (index, className) => {
					return `<div class="main-news--slider__nav--item ${className}"></div>`;
				}
			},
			on: {
				slideChangeTransitionEnd: function () {
					const currentSlide = this.slides[this.activeIndex] as HTMLElement;
					const backgroundImgActive = document.querySelector('.main-news--background__img._active') as HTMLElement;
					const backgroundImgCurrent = document.querySelector('.main-news--background__img_' + currentSlide.dataset.slideId) as HTMLElement;
					backgroundImgActive.classList.remove('_active');
					backgroundImgCurrent.classList.add('_active');
				},
			}
		})
	}
}

export default MainNewSlider;
